import { render, staticRenderFns } from "./SidebarNotification.vue?vue&type=template&id=23ada8fe&scoped=true"
import script from "./SidebarNotification.vue?vue&type=script&lang=js"
export * from "./SidebarNotification.vue?vue&type=script&lang=js"
import style0 from "./SidebarNotification.vue?vue&type=style&index=0&id=23ada8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ada8fe",
  null
  
)

export default component.exports